import { Box, Heading } from "@chakra-ui/react";
import { ReactMarkdown } from "../../Text";

export const StoriesIntroSection = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  const titleWords = title?.split(" ");
  if (!title && !description) return null;
  return (
    <Box
      w={{ base: "100%", md: "90%" }}
      bg="gray.900"
      pb={{ base: "72px", md: "104px" }}
    >
      {titleWords && (
        <Box mb={{ base: "56px" }} mt={{ base: "32px" }}>
          <Heading
            color="yellow.500"
            fontSize={{ base: "6xl", md: "8xl", lg: "6xl" }}
            as="span"
          >
            {`${titleWords[0]} `}
          </Heading>
          <Heading
            color="white"
            fontSize={{ base: "6xl", md: "8xl", lg: "6xl" }}
            fontWeight="thin"
            as="span"
          >
            {` ${titleWords.slice(1).join(" ")}`}
          </Heading>
        </Box>
      )}
      {description && (
        <Box width={{ base: "100%", md: "90%" }} maxW={"600px"}>
          <ReactMarkdown
            textProps={{
              fontSize: { base: "lg", md: "2xl" },
              color: "white",
              fontFamily: "heading",
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            {description}
          </ReactMarkdown>
        </Box>
      )}
    </Box>
  );
};
